// widget/src/widget.tsx
// Lifted from spikes/widget-shadow-dom/src/widget.tsx (Spike 1) per Task 4 plan amendment
// (creation deferred from Task 4 to Task 27b so the App import would resolve).
//
// Two adjustments vs. the spike:
//   1. styles import path: './styles.css' -> './styles/tailwind.css' (Phase 2 layout differs).
//   2. <App /> props: spike passed shadowRoot; Phase 2's App reads vendor-id + api-base
//      from this custom element's attributes (set by the bootloader) and takes no
//      shadowRoot prop. The shadow-root mount itself is unchanged.

import { createRoot } from 'react-dom/client'
import { App } from './App' // PHASE 2: import path differs from spike — see Task 4 plan amendment
// tsup `loader: { '.css': 'text' }` makes this import return the raw CSS text.
import stylesText from './styles/tailwind.css' // PHASE 2: import path differs from spike — see Task 4 plan amendment

class MiklaChat extends HTMLElement {
  connectedCallback() {
    const shadow = this.attachShadow({ mode: 'open' })

    const sheet = new CSSStyleSheet()
    sheet.replaceSync(stylesText)
    shadow.adoptedStyleSheets = [sheet]

    const mount = document.createElement('div')
    shadow.appendChild(mount)

    const vendorId = this.getAttribute('vendor-id') || ''
    const apiBase = this.getAttribute('api-base') || ''

    createRoot(mount).render(<App vendorId={vendorId} apiBase={apiBase} />)
  }
}

if (!customElements.get('mikla-chat')) {
  customElements.define('mikla-chat', MiklaChat)
}
